'use strict';

const classNames = {
	footerNavigation: 'review-footer-nav',
	stickyFooter: 'review-sticky-footer',
	footerNavigationToggle: 'footer-navigation-toggle',
	arrow: 'arrow',
	closeIcon: 'close-icon'
};

const modifiers = {
	close: 'close'
};

export default {
	init() {
		const closeArrowClass = $.getBemClass(classNames.stickyFooter, classNames.arrow, modifiers.close);
			
		$.findByBem(classNames.footerNavigationToggle).on('click', function () {
			$.findByBem(classNames.stickyFooter, classNames.arrow).toggleClass(closeArrowClass);
			$.findByBem(classNames.footerNavigation).slideToggle();
		});
	}
}
